import {
    SET_LOADING,
    UNSET_LOADING
} from '../mutation-types';

const initialState = {
    active: false,
    numCalls: 0
};

const mutations = {
    [SET_LOADING](state) {
        state.numCalls++;
        if (state.numCalls === 1) {
            state.active = true;
        }
    },
    [UNSET_LOADING](state) {
        if (state.numCalls > 0) {
            state.numCalls--;
        }
        if (state.numCalls === 0) {
            state.active = false;
        }
    }
};

export default {
    state: initialState,
    mutations
}